import React, { Component } from 'react'
import IconButton from '@material-ui/core/IconButton'
import PlayIcon from '@material-ui/icons/PlayCircleFilled'
import StopIcon from '@material-ui/icons/Stop'
import KeyboardRightIcon from '@material-ui/icons/KeyboardArrowRight'
import KeyboardLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
//import { SpeakText } from './Speak'
//import { LoadSpeak } from './Speak'
import TextField from '@material-ui/core/TextField'
//import Gamepad from '../dashboard/Gamepad'
//import Sets from '../shared/Sets';
import Button from '@material-ui/core/Button'
import GamepadReact from '../gamepad/GamepadReact'
import './PlayVerbs.scss'

let mar = true
let G_timer
let Timer_Between_Words
let AllWordsPlayed

let sub_id = -1
let speak_section = 'Past'

let current_section = { ID: 1, Name: 'Language1' }
const sub_sections = [
  { ID: 1, Name: 'Language1', Speak: true },
  { ID: 2, Name: 'PresentParticiple', Speak: false },
  { ID: 3, Name: 'PastParticiple', Speak: false },
  { ID: 4, Name: 'Present', Speak: true },
  { ID: 5, Name: 'Past', Speak: true },
  { ID: 6, Name: 'Past1', Speak: false },
  { ID: 7, Name: 'Future', Speak: false },
  { ID: 8, Name: 'Conditional', Speak: false },
  { ID: 9, Name: 'Imperativ', Speak: false },
  { ID: 10, Name: 'Imperativ1', Speak: false },
]

var spa_found = false
var G_spanish_voice = ''
// function GerSpanishVoice(){
//     var voices = speechSynthesis.getVoices();
//       voices.forEach(function(voice, i) {
//       if(voice.name.toLowerCase().indexOf("mex") != -1)
//       {
//         G_spanish_voice = voice.name;
//         spa_found=true;
//       }
//       else if(voice.name.toLowerCase().indexOf("span") != -1 && !spa_found)
//       {
//         G_spanish_voice = voice.name;
//       }

//       });
//   }

var Util = {}
Util.base64 = function (mimeType, base64) {
  return 'data:' + mimeType + ';base64,' + base64
}

var video = document.createElement('video')
video.setAttribute('loop', '')

function addSourceToVideo(element, type, dataURI) {
  var source = document.createElement('source')
  source.src = dataURI
  source.type = 'video/' + type
  element.appendChild(source)
}

addSourceToVideo(
  video,
  'webm',
  Util.base64(
    'video/webm',
    'GkXfo0AgQoaBAUL3gQFC8oEEQvOBCEKCQAR3ZWJtQoeBAkKFgQIYU4BnQI0VSalmQCgq17FAAw9CQE2AQAZ3aGFtbXlXQUAGd2hhbW15RIlACECPQAAAAAAAFlSua0AxrkAu14EBY8WBAZyBACK1nEADdW5khkAFVl9WUDglhohAA1ZQOIOBAeBABrCBCLqBCB9DtnVAIueBAKNAHIEAAIAwAQCdASoIAAgAAUAmJaQAA3AA/vz0AAA='
  )
)
addSourceToVideo(
  video,
  'mp4',
  Util.base64(
    'video/mp4',
    'AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAAG21kYXQAAAGzABAHAAABthADAowdbb9/AAAC6W1vb3YAAABsbXZoZAAAAAB8JbCAfCWwgAAAA+gAAAAAAAEAAAEAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAIVdHJhawAAAFx0a2hkAAAAD3wlsIB8JbCAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAIAAAACAAAAAABsW1kaWEAAAAgbWRoZAAAAAB8JbCAfCWwgAAAA+gAAAAAVcQAAAAAAC1oZGxyAAAAAAAAAAB2aWRlAAAAAAAAAAAAAAAAVmlkZW9IYW5kbGVyAAAAAVxtaW5mAAAAFHZtaGQAAAABAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAAEcc3RibAAAALhzdHNkAAAAAAAAAAEAAACobXA0dgAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAIAAgASAAAAEgAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABj//wAAAFJlc2RzAAAAAANEAAEABDwgEQAAAAADDUAAAAAABS0AAAGwAQAAAbWJEwAAAQAAAAEgAMSNiB9FAEQBFGMAAAGyTGF2YzUyLjg3LjQGAQIAAAAYc3R0cwAAAAAAAAABAAAAAQAAAAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAEAAAABAAAAFHN0c3oAAAAAAAAAEwAAAAEAAAAUc3RjbwAAAAAAAAABAAAALAAAAGB1ZHRhAAAAWG1ldGEAAAAAAAAAIWhkbHIAAAAAAAAAAG1kaXJhcHBsAAAAAAAAAAAAAAAAK2lsc3QAAAAjqXRvbwAAABtkYXRhAAAAAQAAAABMYXZmNTIuNzguMw=='
  )
)

export class PlayVerbs extends Component {
  state = {
    playON: false,
    AllWordsPlayed: true,
    currentWordId: 0,
    Verzug: 3,
    settings_verbs: [],
    voices: [],
  }

  SpeakAdditionlLanguage = () => {
    let text_speak
    if (this.props.settingSpeak.Past) {
      text_speak = this.props.verbs[this.state.currentWordId]['Past'][0]
    }
    if (this.props.settingSpeak.Present) {
      text_speak = this.props.verbs[this.state.currentWordId]['Present'][2]
    }
    if (text_speak) {
      const myArr = text_speak.split(' ')
      if (myArr.length > 0) {
        this.SpeakText(myArr[myArr.length - 1])
      }
    }
  }

  NextVerb = () => {
    this.SpeakAdditionlLanguage()

    setTimeout(this.GamepadPressed, 1500, 'right')
  }

  onPlayclick = () => {
    var newplayON = true
    if (this.state.playON) {
      newplayON = false
    }

    this.setState({
      playON: newplayON,
    })
    if (newplayON) {
      // AllWordsPlayed = true;
      this.setState({
        AllWordsPlayed: true,
      })
      this.SpeakText(this.props.verbs[0].Language1)
      // this.process_next_word(true);
    } else {
      speechSynthesis.cancel()
    }
    video.play()
  }

  Sleep = (milliseconds) => {
    var start = new Date().getTime()
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break
      }
    }
    alert('sadasd')
  }

  componentWillMount() {
    console.log(this.state.voices)
    const voiceschanged = () => {
      let voi = speechSynthesis.getVoices()

      this.setState({
        voices: voi,
      })

      console.log(voi)
      console.log(this.props.settingSpeak)
    }

    if (speechSynthesis.onvoiceschanged !== undefined) {
      speechSynthesis.onvoiceschanged = voiceschanged
    }
    voiceschanged()
  }

  componentDidMount() {
    document.addEventListener(
      'keydown',
      (event) => {
        const keyName = event.key
        if (keyName == 'ArrowRight') {
          this.GamepadPressed('right')
        } else if (keyName == 'ArrowLeft') {
          this.GamepadPressed('left')
        } else if (keyName == 'ArrowDown') {
          this.GamepadPressed('down')
        } else if (keyName == 'ArrowUp') {
          this.GamepadPressed('up')
        }
      },
      false
    )
  }

  GamepadPressed = (g_command) => {
    //  alert(this.props.verbs[this.state.currentWordId]["PastParticiple"]);
    //alert(Object.keys(this.props.verbs[this.state.currentWordId])[5]);
    let speak_verb = ''
    speechSynthesis.cancel()
    if (g_command == 'right') {
      let id = this.process_next_word(true)
      this.SpeakText(this.props.verbs[id].Language1)
      sub_id = -1
    }
    if (g_command == 'left') {
      let id = this.process_next_word(false)
      this.SpeakText(this.props.verbs[id].Language1)
      sub_id = -1
    }
    if (g_command == 'up') {
      sub_id--
      if (sub_id < 0) {
        sub_id = 5
      }
      if (
        speak_section != 'PresentParticiple' &&
        speak_section != 'PastParticiple'
      ) {
        //  alert(speak_section);
        speak_verb =
          this.props.verbs[this.state.currentWordId][speak_section][sub_id]
      } else {
        speak_verb = this.props.verbs[this.state.currentWordId][speak_section]
      }
      //     speak_verb = this.props.verbs[this.state.currentWordId].Past[sub_id];
      //  alert(speak_verb);
      if (speak_verb != '') {
        this.SpeakText(speak_verb)
      }
    }
    if (g_command == 'down') {
      sub_id++
      if (sub_id > 5) {
        sub_id = 0
      }
      if (
        speak_section != 'PresentParticiple' &&
        speak_section != 'PastParticiple'
      ) {
        //    alert(speak_section);
        speak_verb =
          this.props.verbs[this.state.currentWordId][speak_section][sub_id]
        speak_verb = speak_verb.trim()
        if (speak_verb == '-') {
          sub_id++
          speak_verb =
            this.props.verbs[this.state.currentWordId][speak_section][sub_id]
        }
      } else {
        speak_verb = this.props.verbs[this.state.currentWordId][speak_section]
      }
      //   speak_verb = this.props.verbs[this.state.currentWordId].Past[sub_id];
      //   alert(speak_verb);
      if (speak_verb != '') {
        //      alert(speak_verb);
        this.SpeakText(speak_verb)
      }
    }
    //g_command=="L"||g_command=="R"
    if (g_command == 'L') {
      speak_verb = this.props.verbs[this.state.currentWordId].Language2
      if (speak_verb != '') {
        //      alert(speak_verb);
        this.SpeakText(speak_verb)
      }
    }
    if (g_command == 'R') {
      speak_verb = this.props.verbs[this.state.currentWordId].Description1
      if (speak_verb != '' && speak_verb != null) {
        //      alert(speak_verb);
        this.SpeakText(speak_verb)
      }
    }

    if (g_command == 'Select') {
      speak_verb =
        this.props.verbs[this.state.currentWordId]['PresentParticiple']
      if (speak_verb != '' && speak_verb != null) {
        this.SpeakText(speak_verb)
      }
    }
    if (g_command == 'Start') {
      speak_verb = this.props.verbs[this.state.currentWordId]['PastParticiple']
      if (speak_verb != '' && speak_verb != null) {
        this.SpeakText(speak_verb)
      }
    }

    if (g_command == 'B') {
      //alert("A");
      if (speak_section == 'Start' || speak_section == 'End') {
        speak_section = 'Present'
        if (this.props.settingSpeak.Present) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'Present') {
        speak_section = 'Past'
        if (this.props.settingSpeak.Past) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'Past') {
        speak_section = 'Past1'
        if (this.props.settingSpeak.Past1) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'Past1') {
        speak_section = 'Future'
        if (this.props.settingSpeak.Future) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'Future') {
        speak_section = 'Conditional'
        if (this.props.settingSpeak.Conditional) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'Conditional') {
        speak_section = 'Imperativ'
        if (this.props.settingSpeak.Imperativ) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'Imperativ') {
        speak_section = 'Imperativ1'
        if (this.props.settingSpeak.Imperativ1) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'Imperativ1') {
        speak_section = 'PresentParticiple'
        if (this.props.settingSpeak.PresentParticiple) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'PresentParticiple') {
        speak_section = 'PastParticiple'
        if (this.props.settingSpeak.PastParticiple) {
        } else {
          return this.GamepadPressed('B')
        }
      } else if (speak_section == 'PastParticiple') {
        speak_section = 'Start'
        return this.GamepadPressed('right')
      }

      speak_verb =
        this.props.verbs[this.state.currentWordId][speak_section][sub_id]
      if (speak_verb != '') {
        this.SpeakText(speak_verb)
      }
    }

    if (g_command == 'A') {
      //alert("A");
      if (speak_section == 'End' || speak_section == 'Start') {
        speak_section = 'PastParticiple'
        if (this.props.settingSpeak.PastParticiple) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'Past') {
        speak_section = 'Present'
        if (this.props.settingSpeak.Present) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'Past1') {
        speak_section = 'Past'
        if (this.props.settingSpeak.Past) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'Future') {
        speak_section = 'Past1'
        if (this.props.settingSpeak.Past1) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'Conditional') {
        speak_section = 'Future'
        if (this.props.settingSpeak.Future) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'Imperativ') {
        speak_section = 'Conditional'
        if (this.props.settingSpeak.Conditional) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'Imperativ1') {
        speak_section = 'Imperativ'
        if (this.props.settingSpeak.Imperativ) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'PresentParticiple') {
        speak_section = 'Imperativ1'
        if (this.props.settingSpeak.Imperativ1) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'PastParticiple') {
        speak_section = 'PresentParticiple'
        if (this.props.settingSpeak.PresentParticiple) {
        } else {
          return this.GamepadPressed('A')
        }
      } else if (speak_section == 'Present') {
        speak_section = 'End'
        return this.GamepadPressed('left')
      }

      speak_verb =
        this.props.verbs[this.state.currentWordId][speak_section][sub_id]
      if (speak_verb != '') {
        this.SpeakText(speak_verb)
      }
    }

    if (g_command == 'X') {
      if (speak_section == 'Present') speak_section = 'Past'
      else if (speak_section == 'Past') speak_section = 'Past1'
      else if (speak_section == 'Past1') speak_section = 'Future'
      else if (speak_section == 'Future') speak_section = 'Conditional'
      else if (speak_section == 'Conditional') speak_section = 'Imperativ'
      else if (speak_section == 'Imperativ') speak_section = 'Imperativ1'
      else if (speak_section == 'Imperativ1')
        speak_section = 'Present_Subjunctive'
      else if (speak_section == 'Present_Subjunctive')
        speak_section = 'PresentParticiple'
      else if (speak_section == 'PresentParticiple')
        speak_section = 'PastParticiple'
      else if (speak_section == 'PastParticiple') speak_section = 'Present'
      sub_id = -1
      //  alert(speak_section);
      this.SpeakText(speak_section)
    }
    if (g_command == 'Y') {
      //   alert("Y");

      if (speak_section == 'Past') speak_section = 'Present'
      else if (speak_section == 'Past1') speak_section = 'Past'
      else if (speak_section == 'Future') speak_section = 'Past1'
      else if (speak_section == 'Conditional') speak_section = 'Future'
      else if (speak_section == 'Imperativ') speak_section = 'Conditional'
      else if (speak_section == 'Imperativ1') speak_section = 'Imperativ'
      else if (speak_section == 'Present_Subjunctive')
        speak_section = 'Imperativ1'
      else if (speak_section == 'PresentParticiple')
        speak_section = 'Present_Subjunctive'
      else if (speak_section == 'PastParticiple')
        speak_section = 'PresentParticiple'
      else if (speak_section == 'Present') speak_section = 'PastParticiple'
      sub_id = -1
      //  alert(speak_section);
      this.SpeakText(speak_section)
    }
  }

  process_next_word = (ascending) => {
    clearInterval(G_timer)
    let id
    if (ascending) {
      id = this.state.currentWordId + 1
      if (id >= this.props.verbs.length) {
        id = 0
      }
    } else {
      id = this.state.currentWordId - 1
      if (id < 0) {
        id = this.props.verbs.length - 1
      }
    }

    if (id < this.props.verbs.length) {
      if (this.props.verbs[id].Language1 != '') {
        //  NextSubVerb();
        //   SpeakText1(text)
      }

      this.setState({
        currentWordId: id,
      })
      this.props.changeCurrentID(id)
    }
    return id
  }

  SpeakText(text) {
    //     clearInterval(Timer_Between_Words);
    var msg = new SpeechSynthesisUtterance()
    var voices = window.speechSynthesis.getVoices()
    var Play = this
    console.log(this.props.user_settings.FrenchVoice)
    let french = this.props.user_settings.FrenchVoice
    let italian = this.props.user_settings.ItalianVoice
    let spanish = this.props.user_settings.SpanishVoice
    let german = this.props.user_settings.GermanVoice
    //alert(french);
    //   this.props.settingSpeak.SpanishVoice

    //  var voiceSelect = document.getElementById('voice');
    //  if (voiceSelect.value) {
    //      msg.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name == voiceSelect.value; })[0];
    //  }
    //   alert(this.props.verbs[this.state.currentWordId].Language1);
    // alert(this.props.verbs[this.state.currentWordId].set);
    console.log(this.props.verbs[this.state.currentWordId].set)
    if (this.props.verbs[this.state.currentWordId].set == 'French') {
      //  msg.voice = this.state.voices.filter(voice => /fr/.test(voice.lang))[0];
      var new_voices = this.state.voices.filter(function (voice) {
        return voice.name == french
      })[0]
      msg.voice = new_voices
      msg.lang = new_voices.lang

      //  msg.voice = this.state.voices.filter(function(voice) { return voice.name == french; })[0];
    } else if (this.props.verbs[this.state.currentWordId].set == 'Italian') {
      //    alert(italian);
      //  msg.voice = this.state.voices.filter(voice => /it/.test(voice.lang))[0];
      var new_voices = this.state.voices.filter(function (voice) {
        return voice.name == italian
      })[0]
      msg.voice = new_voices
      msg.lang = new_voices.lang

      //  msg.voice = this.state.voices.filter(function(voice) { return voice.name == italian; })[0];
      // msg.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name == italian; })[0];
    } else if (this.props.verbs[this.state.currentWordId].set == 'German') {
      var new_voices = this.state.voices.filter(function (voice) {
        return voice.name == german
      })[0]
      msg.voice = new_voices
      msg.lang = new_voices.lang
    }
    if (this.props.verbs[this.state.currentWordId].set == 'Spanish') {
      //   msg.voice = this.state.voices.filter(voice => /es/.test(voice.lang))[0];
      var new_voices = this.state.voices.filter(function (voice) {
        return voice.name == spanish
      })[0]
      msg.voice = new_voices
      msg.lang = new_voices.lang
    } else if (G_spanish_voice != '') {
      //      msg.voice = this.state.voices.filter(voice => /es/.test(voice.lang))[0];
      var new_voices = this.state.voices.filter(function (voice) {
        return voice.name == spanish
      })[0]
      msg.voice = new_voices
      msg.lang = new_voices.lang
    }
    msg.text = text

    //   props.user_settings.
    msg.rate = Play.props.user_settings.Speed
    //   console.log(this);
    msg.onend = function (e) {
      if (Play.state.playON && Play.state.AllWordsPlayed) {
        //    console.log(this);
        G_timer = setInterval(
          () => Play.NextSubVerb(),
          Play.props.settingSpeak.Verzug * 1000
        )
      }
    }
    //mario 11.7.2019
    speechSynthesis.speak(msg)
  }

  NextVerb() {
    this.process_next_word(true)
    current_section = { ID: 1, Name: 'Language1' }
    this.SpeakText(this.props.verbs[this.state.currentWordId].Language1)
    sub_id = -1
  }

  NextSubVerb() {
    clearInterval(G_timer)
    let speak_verb = ''
    sub_id++
    if (current_section.Name == 'Language1') {
      sub_id = -1
      this.NextSubSection()
      return
    }

    if (
      current_section.Name != 'PresentParticiple' &&
      current_section.Name != 'PastParticiple' &&
      current_section.Name != 'Language1'
    ) {
      if (sub_id > 5) {
        sub_id = -1
        this.NextSubSection()
        return
      }
    } else {
      if (sub_id > 0) {
        sub_id = -1
        this.NextSubSection()
        return
      }
    }

    if (
      current_section.Name != 'PresentParticiple' &&
      current_section.Name != 'PastParticiple' &&
      current_section.Name != 'Language1'
    ) {
      speak_verb =
        this.props.verbs[this.state.currentWordId][current_section.Name][sub_id]
      speak_verb = speak_verb.trim()
      //   alert("11");
      if (speak_verb == '-') {
        // alert("as");
        sub_id++
        speak_verb =
          this.props.verbs[this.state.currentWordId][current_section.Name][
            sub_id
          ]
      }
    } else {
      speak_verb =
        this.props.verbs[this.state.currentWordId][current_section.Name]
    }
    if (speak_verb != '') {
      this.SpeakText(speak_verb)
    }
  }

  NextSubSection() {
    sub_sections[3].Speak = this.props.settingSpeak.Present
    sub_sections[4].Speak = this.props.settingSpeak.Past
    sub_sections[5].Speak = this.props.settingSpeak.Past1
    sub_sections[6].Speak = this.props.settingSpeak.Future
    sub_sections[7].Speak = this.props.settingSpeak.Conditional
    sub_sections[8].Speak = this.props.settingSpeak.Imperativ
    sub_sections[9].Speak = this.props.settingSpeak.Imperativ1

    let next_found = false

    for (var i = 0; i < sub_sections.length; i++) {
      if (sub_sections[i].ID > current_section.ID) {
        if (sub_sections[i].Speak) {
          current_section.ID = sub_sections[i].ID
          current_section.Name = sub_sections[i].Name
          next_found = true
          break
        }
      }
    }
    // sub_sections.map(s=>{
    //     if(s.ID>current_section.ID)
    //     {
    //         if(s.Speak)
    //         {
    //             current_section.ID = s.ID;
    //             current_section.Name = s.Name;
    //             next_found=true;
    //             break;
    //         }
    //     }
    // })
    if (next_found) {
      //    alert("found: "+current_section.Name);
      sub_id = -1
      this.NextSubVerb()
    } else {
      //   alert("not found: "+current_section.Name);
      this.NextVerb()
    }

    //   this.SpeakText(current_section.Name);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
  }
  speakDivClick = (e) => {
    this.SpeakText(
      document.getElementById('speakdiv').innerHTML,
      this.props.settingSpeak[document.getElementById('voicediv').innerHTML]
    )
    //alert(this.props.settingSpeak[document.getElementById('voicediv').innerHTML]);
  }

  render() {
    //  GerSpanishVoice();
    return (
      <div>
        {/* <Gamepad GamepadPressed={this.GamepadPressed}></Gamepad> */}
        <GamepadReact GamepadPressed={this.GamepadPressed}></GamepadReact>

        <section className="buttons">
          <Button
            className="btn-left"
            onClick={() => this.GamepadPressed('left')}
            color="secondary"
          >
            <KeyboardLeftIcon></KeyboardLeftIcon>
          </Button>

          <Button
            className="btn-play"
            onClick={() => this.onPlayclick()}
            aria-label="Edit"
          >
            {this.state.playON ? <StopIcon /> : <PlayIcon />}
          </Button>

          <Button
            className="btn-right"
            onClick={() => this.NextVerb()}
            color="secondary"
          >
            <KeyboardRightIcon></KeyboardRightIcon>
          </Button>
        </section>

        {/* <Button onClick={() => this.process_next_word(false)} color="secondary">
          Anterior
        </Button>
        <Button onClick={() => this.process_next_word(true)} color="secondary">
          Proximo
        </Button>

        <br></br>

        <IconButton onClick={() => this.onPlayclick()} aria-label="Edit">
          {this.state.playON ? <StopIcon /> : <PlayIcon />}
        </IconButton> */}

        <div hidden id="speakdiv" onClick={() => this.speakDivClick()}></div>
        <div hidden id="voicediv"></div>
      </div>
    )
  }
}

export default PlayVerbs
